<template>
  <div class="html">
    <banner
      :title="title"
      :content="content"
    />
    <div class="introduce">
      <p class="sub_title">
        服务介绍
      </p>
      <div class="content_A">
        <div class="content_list">
          <div>
            渗透测试服务在技术层面包含但不仅限于从系统层、应用层进行开展，针对不同层面的安全漏洞及威胁，多方位多角度的测试，保证渗透测试的全面性。并且结合不同的漏洞提出修补建议及回归测试。主要输出服务内容如下：
          </div>
          <div
            v-for="introduce in introduceList"
            :key="introduce.id"
            class="list"
          >
            <div>{{ introduce.title }}</div>
            <div>
              {{ introduce.content }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="procedure">
      <p class="sub_title">
        服务流程
      </p>
      <div class="lct">
        <img
          src="@/assets/securityServices/seep1.png"
          alt=""
        >
      </div>
    </div>
    <div class="cost">
      <p class="sub_title">
        服务价值
      </p>
      <div class="lists">
        <div
          v-for="item in costList"
          :key="item.id"
          class="list"
        >
          <div class="item_list">
            <img
              :src="item.imgUrl"
              alt=""
            >
            <div class="content">
              <p>{{ item.title }}</p>
              <p>{{ item.content }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from '@/views/securityServices/components/banner.vue'
export default {
  name: 'Seep',
  components: {
    banner
  },
  data() {
    return {
      title: '渗透测试服务',
      content:
        '在用户的授权和监督下， 充分利用测试团队的攻防渗透能力， 完全模拟黑客可能使用的攻击技术和漏洞发现技术， 对目标系统的安全做深入的探测， 发现系统最脆弱的环节， 充分挖掘业务系统可能被攻击者利用的安全漏洞， 并针对安全漏洞提出整改修复建议、 协助用户修复安全淜洞、 对漏洞修复情况进行复核工作。',
      introduceList: [
        {
          id: 1,
          title: '系统层安全渗透测试：',
          content:
            '针对Windows、Solaris、AIX、Linux、SCO、SGI等操作系统进行渗透测试，主动发现操作系统存在的各种漏洞：如弱口令、本地溢出漏洞、敏感信息泄露、系统安全管理、安全基线等漏洞。 '
        },
        {
          id: 2,
          title: 'WEB中间件渗透测试：',
          content:
            ' 针对WEB常见的软件，例如APACHE、IIS、TOMCAT中间件等重点测试自身存在一些由于版本较低或配置不当所造成的安全隐患和漏洞。'
        },
        {
          id: 3,
          title: 'WEB应用渗透测试：',
          content:
            ' 针对WEB常见的应用，重点测试由于安全设计不足和开发不规范所造成的隐患和漏洞，如：身份验证、sql注入、木马上传、任意文件下载、业务逻辑等漏洞。 '
        },
        {
          id: 4,
          title: '提供整改建议和复测：',
          content:
            ' 为制定或调整企业应用系统安全策略提供参考。对信息系统进行回归测试，确保安全问题已得到防护。 '
        }
      ],

      costList: [
        {
          id: 1,
          title: '全面安全检测',
          imgUrl: require('@/assets/securityServices/risk1.png'),
          content:
            '让单位清晰了解目前业务系统的安全短板，以便采取必要的防范措施。'
        },
        {
          id: 2,
          index: '02',
          title: '安全能力提升',
          imgUrl: require('@/assets/securityServices/risk2.png'),
          content: '提高单位各部门对整体网络安全的认知程度和安全能力。'
        },
        {
          id: 3,
          index: '03',
          title: '合法合规运营',
          imgUrl: require('@/assets/securityServices/risk3.png'),
          content: '满足等保、风险评估基本要求，避免企业触犯法律。'
        }
      ]
    }
  }
}
</script>
<style scoped>
@import '../../styles/utils.scss';
@media (min-width: 1200px)and (max-width: 1350px) {
  .procedure .sub_title{
    font-size: 35px;
  }
  .cost .sub_title{
    font-size: 35px;
  }

}
</style>
